// Import model
import { StartRoomSelectionEditItemRequest } from '../models/StartRoomSelectionEditItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartRoomSelectionEditItemRequest - handles JSON serialization and deserialization with type validation
 */
export class StartRoomSelectionEditItemRequestSerializer {
  /**
   * Deserializes a JSON string into a StartRoomSelectionEditItemRequest instance
   */
  static deserialize(json: string): StartRoomSelectionEditItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartRoomSelectionEditItemRequest instance
   */
  static fromObject(obj: any): StartRoomSelectionEditItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartRoomSelectionEditItemRequest');
    }


    const instance: StartRoomSelectionEditItemRequest = {
      source: obj['source'] as string | undefined,
      itemId: obj['itemId'] as string | undefined,
      margin: obj['margin'] as number | undefined,
      wasteFactor: obj['wasteFactor'] as number | undefined,
      quantity: obj['quantity'] as number | undefined,
      uom: obj['uom'] as string | undefined,
      unitCost: obj['unitCost'] as number | undefined,
      uomAbbreviation: obj['uomAbbreviation'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartRoomSelectionEditItemRequest instances
   */
  static deserializeArray(json: string): StartRoomSelectionEditItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartRoomSelectionEditItemRequest instance to a JSON string
   */
  static serialize(instance: StartRoomSelectionEditItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartRoomSelectionEditItemRequest instance to a plain object
   */
  static toObject(instance: StartRoomSelectionEditItemRequest): any {
    return {
      'source': instance.source,
      'itemId': instance.itemId,
      'margin': instance.margin,
      'wasteFactor': instance.wasteFactor,
      'quantity': instance.quantity,
      'uom': instance.uom,
      'unitCost': instance.unitCost,
      'uomAbbreviation': instance.uomAbbreviation,
    };
  }

  /**
   * Serializes an array of StartRoomSelectionEditItemRequest instances to a JSON string
   */
  static serializeArray(instances: StartRoomSelectionEditItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
